import excelApi from '@/api/excel.api'


const actions = {
  async getProjectsWithEventsXlsx ({ rootState }, seasonId) {
    const response = await excelApi.getProjectsWithEventsXlsx(rootState.tenant.current, seasonId)
    return response.data
  }
}


export default {
  actions
}
